import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-scroll';

export default function Banner({ bannerImage, bannerMainText, bannerSubText }) {
    return (
        <Box component={"div"} sx={{ backgroundImage: `url(${bannerImage})`, backgroundPosition: 'center bottom', backgroundSize: 'cover', height: '100vh', width: '100%', display: "flex", alignContent: "center" }}>
            <Box className="banner-text-container">
                <h1 className="banner-main-text animate__animated animate__fadeInLeft">{bannerMainText}</h1>
                <Typography variant='h4' component={"h2"} className="banner-sub-text animate__animated animate__fadeInLeft">{bannerSubText}</Typography>
                <Link to="ourPassion" smooth={true} duration={500}>
                    <Button className='banner-btn animate__animated animate__fadeInLeft' component={"button"} variant='contained' sx={{ width: "150px" }}>Our Passion</Button>
                </Link>
            </Box>
        </Box>
    )
}